"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const Cookies_1 = tslib_1.__importDefault(require("./Cookies"));
const ModuleRegistryFactory_1 = tslib_1.__importDefault(require("../module/ModuleRegistryFactory"));
class LoginTypeUtil {
    static loggedInWithPoces() {
        return ModuleRegistryFactory_1.default.getModuleContext().getUserContext().getCvr() == null;
    }
    static loggedInWithSafeBrowserStartV2() {
        return Cookies_1.default.getCookie(this.SBOV2_MARKER) === "true";
    }
}
LoginTypeUtil.SBOV2_MARKER = "sbov2";
exports.default = LoginTypeUtil;
//# sourceMappingURL=LoginTypeUtil.js.map